import request from '@/utils/request'

/**
 * 系统监控（仅超管）
 * ⛔ 所有接口在服务端都有 RoleConstant.isSuper() 硬校验。
 */

/** 近 N 分钟概览 */
export function getMonitorOverview(params) {
  return request({
    url: '/admin/monitor/overview',
    method: 'get',
    params
  })
}

/** 接口排行（sortBy: total / error / slow） */
export function getMonitorApis(params) {
  return request({
    url: '/admin/monitor/apis',
    method: 'get',
    params
  })
}

/** 安全事件流 */
export function getMonitorEvents(params) {
  return request({
    url: '/admin/monitor/events',
    method: 'get',
    params
  })
}

/** IP 黑白名单 */
export function getIpRules() {
  return request({
    url: '/admin/monitor/ip-rules',
    method: 'get'
  })
}

export function addIpRule(data) {
  return request({
    url: '/admin/monitor/ip-rules',
    method: 'post',
    data
  })
}

export function deleteIpRule(id) {
  return request({
    url: `/admin/monitor/ip-rules/${id}`,
    method: 'delete'
  })
}

/** 我当前的 IP（配白名单唯一安全的取值方式） */
export function getMyIp() {
  return request({
    url: '/admin/monitor/my-ip',
    method: 'get'
  })
}

/** 审计日志 */
export function getAuditLogs(params) {
  return request({
    url: '/admin/monitor/audit',
    method: 'get',
    params
  })
}
